import { AbstractNotification } from '../abstract.notification'
import { NotificationType } from '../notification-type.enum'

export class NotEnoughTicketNotification extends AbstractNotification {
	id = NotificationType.NOT_ENOUGH_TICKET

	constructor() {
		super()
	}
}
